import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { renderInShadow } from "../../../../js/lib/components/ShadowUtils";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { ValidationManager } from "../../../../js/lib/manager/ValidationManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";
import { SimpleErrorDialog } from "./simpleErrorDialog";
import { SuccessMessageControl } from "./successMessageControl";
import * as React from "react";
import Rating from "@mui/material/Rating";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";

export const WriteReviewControl = (function ($) {
  var id = LS2PAC_CONSTANTS.Ids.writeReviewDialog,
    tmpl = "tmpl/controls/writeReviewDialog.html",
    resourceId = undefined,
    preScore = undefined,
    theScore = undefined,
    validationObj = undefined;

  var openDialog = function (review) {
    TemplateEngine.compile(tmpl, { id: id }, function (content) {
      DialogManager.show({
        content: content,
        dialogTitle: ApplicationData.language.addNewReview,
        okText: ApplicationData.language.submit,
        submitCallback: function (event) {
          submitReview(event);
          return false;
        },
        callback: function () {
          if (review) {
            resourceId = review.resourceId;
            preScore = theScore = review.rating;
            $("#" + id + "_title").val(review.title);
            $("#" + id + "_description").val(review.description);
          }

          const defaultRating = preScore || 0;
          renderInShadow(
            <Rating
              name="rating"
              icon={<StarIcon fontSize="inherit" htmlColor="#d77e02" />}
              emptyIcon={
                <StarBorderIcon fontSize="inherit" htmlColor="#99948F" />
              }
              precision={0.5}
              defaultValue={defaultRating}
              onChange={(event, newValue) => {
                keepScore(newValue);
              }}
            />,
            document.querySelector("#rating_" + id),
            ApplicationData.language
          );
        },
      });
    });
  };

  var keepScore = function (score) {
    theScore = score;
  };

  var submitReview = function (event) {
    var review = {
      rating: theScore,
      title: $("#" + id + "_title").val(),
      name: $("#" + id + "_name").val(),
      description: $("#" + id + "_description").val(),
      resourceId: resourceId,
    };

    if (
      ValidationManager.validateSubmit(
        validationObj,
        getValidationErrorCallback(review)
      )
    ) {
      if (!review.rating || review.rating == 0) {
        handleValidationError([], review);
      } else {
        setupResponseListener();
        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onReviewTitle, {
          review: review,
        });
        TLCLogger.log("Review", review);
      }
    }
  };

  var getValidationErrorCallback = function (review) {
    return function (errors) {
      handleValidationError(errors, review);
    };
  };

  var handleValidationError = function (errors, review) {
    if (!review.rating || review.rating == 0) {
      errors.push(ApplicationData.language.starRatingIsRequired);
    }
    TLCLogger.log("errors", errors);
    DialogManager.close({}, false);
    SimpleErrorDialog.showValidationErrors(errors, function () {
      openDialog(review);
    });
  };

  var setupResponseListener = function () {
    TLCEventManager.addOneTimeListener(
      LS2PAC_CONSTANTS.Events.onReviewTitleResponse,
      function (event) {
        if (event.success) {
          var message = ApplicationData.language.reviewSavedAwaitingApproval;
          if (event.response.approved === true) {
            message = ApplicationData.language.reviewSavedApproved;
          }
          SuccessMessageControl.show(message);
        } else {
          SimpleErrorDialog.show(ApplicationData.language.errorSavingReview);
        }
      }
    );
  };

  var setupListeners = function () {
    if (ApplicationData.locationConfiguration.showBorrowerReviewsView()) {
      TLCEventManager.addListener(
        LS2PAC_CONSTANTS.Events.onWriteReview,
        function (event) {
          resourceId = event.resource.id;
          preScore = theScore = event.score;
          LoginClientManager.promptIfNotLoggedIn(function (user) {
            openDialog();
          });
        }
      );
    }
  };

  var setValidatorObject = function () {
    if (!validationObj) {
      validationObj = {
        fields: [
          {
            selector: "#" + id + "_title",
            required: true,
            message: ApplicationData.language.reviewTitleIsRequired,
          },
          {
            selector: "#" + id + "_description",
            required: true,
            message: ApplicationData.language.reviewTextIsRequired,
          },
        ],
      };
    }
    return validationObj;
  };

  return {
    init: function () {
      setupListeners();
      ValidationManager.setValidation(setValidatorObject());
    },
  };
})(jQuery);
